import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface BudgetTrackerModal {
  showBudgetTrackerModal: boolean;
  showBudgetTrackerAlertModal: boolean;
  viewProjectName: string;
  budgetAlertCount: number;
  budgetAlertId: number;
  showBudgetTrackerDeleteToast: boolean;
  viewProjectPageInfo:any
}

const initialState: BudgetTrackerModal = {
  showBudgetTrackerModal: false,
  showBudgetTrackerAlertModal: false,
  budgetAlertCount: 0,
  budgetAlertId: 0,
  viewProjectName: '',
  showBudgetTrackerDeleteToast: false,
  viewProjectPageInfo:{}
};

const BudgetTrackerModalSlice = createSlice({
  name: 'budgetTrackerModal',
  initialState,
  reducers: {
    setShowBudgetTrackerModal(state, action: PayloadAction<boolean>) {
      state.showBudgetTrackerModal = action.payload;
    },
    setShowBudgetTrackerAlertModal(state, action: PayloadAction<boolean>) {
      state.showBudgetTrackerAlertModal = action.payload;
    },
    setBudgetAlertCount(state, action: PayloadAction<number>) {
      state.budgetAlertCount = action.payload;
    },
    setBudgetAlertId(state, action: PayloadAction<number>) {
      state.budgetAlertId = action.payload;
    },
    setShowBudgetTrackerDeleteToast(state, action: PayloadAction<boolean>) {
      state.showBudgetTrackerDeleteToast = action.payload;
    },
    setViewProjectName(state, action: PayloadAction<string>) {
      state.viewProjectName = action.payload;
    },
    setViewProjectPageInfo(state, action: PayloadAction<any>){
      state.viewProjectPageInfo = action.payload
    }
  },
});

export const {
  setShowBudgetTrackerModal,
  setShowBudgetTrackerAlertModal,
  setViewProjectName,
  setBudgetAlertCount,
  setBudgetAlertId,
  setShowBudgetTrackerDeleteToast,
  setViewProjectPageInfo
} = BudgetTrackerModalSlice.actions;

export default BudgetTrackerModalSlice.reducer;
